const lifeCycleEvents = ["created", "mounted", "destroyed"];

export default {
	...lifeCycleEvents.reduce((result, eventName) => {
		result[eventName] = function() {
			this.$emit(eventName);
		};
		return result;
	}, {}),
};
